import axios from "axios";
import {apiUrl} from "../../api/common";
import {Category, CategoryLink} from "../../types/category/category";


export class CategoryHandler {

    public static getCategories() : Promise<Array<Category>> {
        return new Promise<Array<Category>> (function (resolve, reject) {
            axios.get(apiUrl + '/categories' ,{}).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static getCategoriesFather() : Promise<Array<Category>> {
        return new Promise<Array<Category>> (function (resolve, reject) {
            axios.get(apiUrl + '/categories/father' ,{}).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static getCategoryByCode(categoryCode: string) : Promise<Category> {
        return new Promise<Category> (function (resolve, reject) {
            axios.get(apiUrl + '/categories/code/' +categoryCode,{}).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }


    public static getCategoryLinks() : Promise<Array<CategoryLink>> {
        return new Promise<Array<CategoryLink>> (function (resolve, reject) {
            axios.get(apiUrl + '/categoriesLink' ,{}).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static getCategoryLinksByCategoryId(categoryId: string) : Promise<Array<CategoryLink>> {
        return new Promise<Array<CategoryLink>> (function (resolve, reject) {
            axios.get(apiUrl + '/categoriesLink/'+categoryId ,{}).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static getCategoryLinksByProductId(productId: string) : Promise<Array<CategoryLink>> {
        return new Promise<Array<CategoryLink>> (function (resolve, reject) {
            axios.get(apiUrl + '/categoriesLink/'+productId+"/product" ,{}).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static createCategory(category: Category): Promise<any> {
        return new Promise<any> (function (resolve, reject) {
            axios.post(apiUrl + '/categories', category,{}).then((response:any) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err);
            });
        });
    }

    public static createCategoryLink(categoryId: string, productId: string): Promise<any> {
        return new Promise<any> (function (resolve, reject) {
            axios.post(apiUrl + '/categoriesLink/'+productId+"/"+categoryId,null,{}).then((response:any) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err);
            });
        });
    }
}
